import magnifiAPIInstance from "./apiInstance";

export const clipVideosAPIs = {
  getClipVideosByStream: ({ payload }) => magnifiAPIInstance.post(`/api/v3/clip-videos/getByStream`, payload),
  deleteClipVideoById: ({ payload }) => magnifiAPIInstance.delete(`/api/v3/clip-videos/${payload.clipVideoId}`),
  clipVideoBulkDownload: ({ payload }) => magnifiAPIInstance.post(`/api/v3/bulk-download/clip-videos`, payload),
  clipVideoBulkDelete: ({ payload }) => magnifiAPIInstance.delete(`/api/v3/clip-videos`, payload),
};
